<template>
<div class="table-edit-select">
    <el-popover placement="top" width="200" trigger="manual" v-model="editShow">
        <el-link type="primary" slot="reference" @click="editShow = !editShow">{{info.parent?'绑定'+info.parent.code:'无绑定'}} <i class="el-icon-edit"></i></el-link>
        <div class="change-box">
            <el-input v-model="info.parent_code" size="mini" placeholder="请输入关联的核销码" clearable></el-input>
        </div>
        <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="editShow = false">取消</el-button>
            <el-button type="primary" size="mini" @click="sub">确定</el-button>
        </div>
    </el-popover>
</div>
</template>

<script>
export default {
    data() {
        return {
            editShow: false,
        }
    },
    props: {
        info: Object
    },
    methods: {
        sub() {
            this.$util.put('order/verify_codes/quick/' + this.info.id, {
                field: 'parent_code',
                value: this.info.parent_code
            }).then(() => {
                this.editShow = false
                this.$emit('subQuick')
            })
        }
    }
}
</script>

<style scoped>
.change-box {
    margin-bottom: 10px;
}
</style>
